import React, { useCallback, useState } from 'react';
import { mediaUrl } from '../../../content/productMedia';

/** Looping product clip (MP4 + optional WebM/poster) or static image (PNG). */
export default function ProductMediaElement({ asset, src, className = '', loading = 'lazy' }) {
  const [nativeWidth, setNativeWidth] = useState(asset.width ?? null);

  const handleVideoMetadata = useCallback((event) => {
    const { videoWidth } = event.currentTarget;
    if (videoWidth > 0) setNativeWidth(videoWidth);
  }, []);

  if (asset.type === 'mp4') {
    const poster = mediaUrl(asset, 'poster');
    const webm = mediaUrl(asset, 'webm');
    return (
      <video
        autoPlay
        loop
        muted
        playsInline
        preload={poster ? 'metadata' : 'auto'}
        poster={poster || undefined}
        width={asset.width}
        height={asset.height}
        onLoadedMetadata={handleVideoMetadata}
        aria-label={asset.alt}
        className={`product-media-video ${className}`.trim()}
        style={nativeWidth ? { maxWidth: `${nativeWidth}px` } : undefined}
      >
        <source src={src} type="video/mp4" />
        {webm && <source src={webm} type="video/webm" />}
      </video>
    );
  }

  return <img src={src} alt={asset.alt} loading={loading} className={className} width={asset.width} height={asset.height} />;
}
